@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.modal-body {
  width: 100%;
  height: 100%;
  min-height: 200px;
  min-width: 400px;
  padding: @space-16 @space-24;
  font-size: 14px;
}

.confirm-modal-body {
  min-height: 100px;
  width: 400px;
}

.loading-indicator {
  width: 60px;
  height: 60px;
  margin: auto;
}

.import-template-table {
  display: grid;
  grid-template-columns:
    minmax(min-content, 360px)
    max-content;
  border: 1px solid var(--default--border-color--10);
  font-size: 14px;
  margin-top: @space-16;

  thead,
  tbody,
  tr {
    display: contents;
  }

  th {
    display: flex;
    align-items: center;
    min-height: 32px;
    line-height: 18px;
    font-weight: 500;
    background-color: var(--tabs--page--background-color);

    &:first-child {
      padding-left: @space-12;
    }
  }

  td {
    display: flex;
    align-items: center;
    min-height: 50px;
    border-top: 1px solid var(--default--border-color--10);

    &.name-cell {
      padding-left: @space-12;
      padding-right: @space-12;
      width: 100%;
      text-align: left;
    }

    &.actions-cell {
      min-width: 160px;
    }

    span.separator {
      margin-left: @space-8;
      margin-right: @space-8;
      color: var(--grey-400);
    }
  }
}

.save-button {
  padding: @space-0 @space-12;
}

.cancel-button {
  padding: @space-0 @space-16;
}

.mapping-input {
  width: 100%;
}

.icon {
  padding-right: 2px;
  height: 14px;
  width: 14px;
  margin-bottom: -2px;
}

.error {
  width: 100%;
  padding: @space-4;
  background-color: var(--red-100);
}

.input-container {
  padding: @space-8 @space-0;
  width: 100%;
}
